import { filterProps } from '@roc/ui/utils';
import { GridColumnProps } from '@roc/ui';

export const DEFAULT_SORT_MODEL = [{ colId: 'timeInTaskSort', sort: 'desc' }];

export const loansWaitingUnderwriteTaskColumns: GridColumnProps[] = [
  {
    field: 'loanId',
    headerName: 'Loan ID',
    cellRenderer: 'loanIdCellRenderer',
    width: 110,
    ...filterProps(),
  },
  {
    field: 'loanType',
    headerName: 'Loan Type',
    minWidth: 130,
    ...filterProps(),
  },
  {
    field: 'loanStatus',
    headerName: 'Loan Status',
    minWidth: 130,
    ...filterProps(),
  },
  {
    field: 'lenderName',
    headerName: 'Lender',
    minWidth: 160,
    ...filterProps(),
  },
  {
    field: 'loanUnderwriter',
    headerName: 'Underwriter',
    minWidth: 160,
    ...filterProps(),
  },
  {
    field: 'primaryCsc',
    headerName: 'Primary CSC',
    minWidth: 160,
    ...filterProps(),
  },
  {
    field: 'businessTimeInTask',
    headerName: 'Business Time in Task',
    minWidth: 220,
    ...filterProps(),
  },
  {
    field: 'timeInTask',
    headerName: 'Time in Task',
    minWidth: 200,
    ...filterProps(),
  },
  {
    field: 'actions',
    headerName: 'Actions',
    cellRenderer: 'loansWaitingUnderwriteTaskActionsCellRenderer',
    maxWidth: 100,
    sortable: false,
    filter: false,
    pinned: 'right',
    lockPinned: true,
  },
];
